import { app } from '@microsoft/teams-js';
import { useData } from '@microsoft/teamsfx-react';
import { IInstance, LoginData } from '../interfaces';

type DebugInfoProps = {
	graph?: {
		loading: boolean;
		data?: LoginData;
		error: unknown;
		reload: () => void;
	};

	teams?: {
		loading: boolean;
		data:
			| {
					displayName: string;
					objectId: string;
					tenantId: string;
					preferredUserName: string;
			  }
			| undefined;
		error: unknown;
	};

	environments?: IInstance[];
};

export const DebugInfo = ({ graph, teams, environments }: DebugInfoProps) => {
	const friendlyEnvironmentName =
		{
			local: 'local environment',
			azure: 'Azure environment',
		}[window.location.hostname === 'localhost' ? 'local' : 'azure'] || 'local environment';

	const hubName =
		useData(async () => {
			await app.initialize();
			const context = await app.getContext();
			return context.app.host.name;
		})?.data ?? 'unknown app';

	const errorJson = graph?.error ? JSON.stringify(graph.error as any, undefined, 2) 
		: graph?.data?.error ? JSON.stringify(graph.data.error as any, undefined, 2) : '';

	return (
		<div style={{ textAlign: 'left' }}>
			<hr style={{ marginTop: '3rem' }} />
			{graph && (
				<div>
					<h1>Debug info</h1>
					{
						<p>
							Your app is running in <strong>{hubName}</strong> in{' '}
							<strong>{friendlyEnvironmentName}</strong>
						</p>
					}

					<h3>{graph.loading ? 'Loading graph..' : errorJson ? `Graph error` : 'Graph result'}</h3>
					{errorJson ? (
						<div style={{ maxWidth: '80%' }}>
							<div>
								<pre style={{ maxHeight: '20%', overflowY: 'auto' }}>{errorJson}</pre>
							</div>
						</div>
					) : (
						<></>
					)}
					<div style={{ maxHeight: '30%', overflowY: 'auto' }}>
						{graph.data?.profile &&
							Object.entries(graph.data.profile).map((v) => {
								return (
									<div key={v[0]}>
										{v[0]}: <strong>{JSON.stringify(v[1])}</strong>
									</div>
								);
							})}
					</div>
				</div>
			)}

			{teams && (
				<div>
					<h3>{teams.loading ? 'Loading Teams..' : teams.error ? `Teams error.` : 'Teams result'}</h3>
					<div>
						{teams.data &&
							teams.data.displayName +
								' Tenant Id:' +
								teams.data.tenantId +
								' preferredUserName:' +
								teams.data.preferredUserName}
						{
							// Object.entries(teams.data).map((v) => {
							//     return (
							//         <div key={v[0]}>
							//             {v[0]}: <strong>{v[1]}</strong>
							//         </div>
							//     );
							// })
						}
					</div>
				</div>
			)}

			{environments && (
				<div>
					<h3>Discovery results</h3>
					<div>
						<pre style={{ maxHeight: '30%', overflowY: 'auto' }}>
							{JSON.stringify(environments, undefined, 2)}
						</pre>
					</div>
				</div>
			)}
		</div>
	);
};
